import { get, post } from './http';

const baseUrl = process.env.VUE_APP_BASE_URL;

// 获取用户幻灯片文件列表
const getFileList = (params) => get(`${baseUrl}/userSlideFile/list`, params);
// 删除用户幻灯片文件
const removeFile = (params) => post(`${baseUrl}/userSlideFile/delete`, params);
// 下载用户幻灯片文件
const downloadFile = (params) => get(`${baseUrl}/userSlideFile/download`, params);

export default {
  getFileList,
  removeFile,
  downloadFile,
}
